export const skillsToLearn = [
    "React Native",
    "Node.js",
    "Unit Tests",
];